<script>
import Layout from "@layouts/form";
import AlterarSenha from "@forms/AlterarSenha";

export default {
  page: {
    title: "Alterar minha senha"
  },
  components: { Layout, AlterarSenha },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Alterar minha senha",
      items: [
        {
          text: "AlterarSenha",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <AlterarSenha />
    </div>
  </Layout>
</template>
